/* eslint-disable no-use-before-define */
import React from 'react'
import { ajax, Status, getState, cleanObject, arrayToggle, arrayFrom, format,  } from '../twd'
import { fixParams } from './fix-params'

const Last = getState('offerings.last', {ts:0, params:{}})

const getInvType = (searchParams) => {
    let types = arrayFrom((searchParams || {}).holdInvType)
    return types.length===1 ? types[0] : ''
}

export const getCusips = async (cusips) => {

    let {data} = await ajax({
        url:'/esb/repattributes/accountPositions/cusipInfo',
        method: 'POST',
        params: cusips
    })

    let cs = await data
    if (!cs) return []

    Object.values(cs).forEach(c => {
        c.holdInvType = c.type
        c.holdCusip = c.cusip
        c.holdIssue = c.issue_display
        c.holdCoupon = c.coupon
        c.holdMaturity = c.maturity_eff
        c.spRating = '-'
        c.moodyRating = '-'
        c.hodlState = '-'
    })

    let {data:bookdata} = await ajax({
        url:'/esb/portfolio/cusip/warningAndBook',
        method: 'POST',
        params: {
            "p_criteria_fmt":"ADVANCED",
            "p_cusip": cusips.join(),
            "p_maxrows":cusips.length,
            "p_monarch":"Y",
            "p_output_fmt":"JSON",
            "p_multiple":["BOL-UOR","BOL-ROR"],
            "p_submit":"JSON",
            "p_redirect_output":"Y",
            "p_type":"0",
            "p_min_qty":1,
            "p_is_offer_search":false,
            "p_search_criteria":{},
            "p_mode":"RP"
        }
    })

    let ws = (await bookdata) || []

    ws.forEach(w => {
        let n = w.cusip.substring(0,8)
        let c = cs[n]
        if (!c) return

        c.holdWarningText = w.warningText
    })

    return Object.values(cs)
}


export const search = ({searchParams, _ts, from, backFrom}) => {

    let isReset = _ts && Last.value.ts < _ts
    if (isReset) {
        Last.reset()
        Last.set({ts:_ts, from})
    }

    const [status, setStatus] = React.useState(searchParams && !isReset && !backFrom ? Status.LOADING : Status.LOADED)
    const [params, setParams] = React.useState(searchParams || Last.value.params || {})
    const [rows, setRows] = React.useState(Last.value.rows || [])
    const [count, setCount] = React.useState(Last.value.resultSetCount || 0)
    const [page, setPage] = React.useState(Last.value.page || 1)
    const [ts, setTs] = React.useState(_ts || Last.value.ts || 0)
    const [selection, setSelection] = React.useState(Last.value.selection || [])
    const [invType, setInvType] = React.useState(getInvType(searchParams))


    React.useEffect(() => {
        if (!_ts || ts >= _ts) return
        Last.reset()
        setRows([])
        setSelection([])
        setCount(0)
        setPage(1)
        setParams(searchParams)
        setTs(_ts)
        setInvType(getInvType(searchParams))
    }, [_ts])


    React.useEffect(() => {
        if (!ts || !params || page===Last.value.page) return

        setStatus(Status.LOADING)
        ;(async ()=> {
            try {
                let isGlobalSearch = params.origin === 'global-search'
                if (isGlobalSearch) {
                    delete params.origin
                }

                let p = toParams(params, page)
                if (page===1) {
                    p.metadata = { searchType:'offers', ...params}
                }

                let {data} = await ajax({
                    url:'/esb/portfolio/offersearch',
                    method: 'POST',
                    params: p
                })

                let a = await data
                let hasOffers = true
                if (arrayFrom(a.rows).length===0
                    && arrayFrom(p.holdCusip).length >0
                    && isGlobalSearch
                ) {
                    hasOffers = false
                    a.rows = await getCusips(p.holdCusip)
                    a.searchCriteria = []
                    a.resultSetCount = a.rows.length
                }

                if (hasOffers) {
                    let cs = Object.keys(a.offerSearchColumnSettings || {})
                    let i = cs.length===1 ? cs[0] : ''
                    if (i) setInvType(i)
                } else {
                    setInvType('-')
                }

                let filtered = 0
                a.rows = arrayFrom(a.rows)
                    .map(r => {
                        let { holdWarningText, holdFirstCall, holdFirstCallCost, marketCheck } = r
                        if (marketCheck==='z' || marketCheck==='Z') {
                            filtered++
                            return null;
                        }

                        let ct = holdFirstCall
                            ? `Callable ${format.fmtDt(holdFirstCall, 'MM/yy')}@${holdFirstCallCost}${holdWarningText ? ' | ': ''}`
                            : ''

                        Object.assign(r, {holdWarningText: ct + holdWarningText })
                        return r
                    })
                    .filter(Boolean)
                a.rows = (Last.value.rows || []).concat(a.rows)

                Last.set({params, page}, a)

                setRows(a.rows)
                setCount(a.resultSetCount - filtered)
                setStatus(Status.LOADED)
            } catch(e) {
                setStatus(Status.FAILED_TO_LOAD)
            }
        })()

    }, [ts, params, page])

    const onLoadMore = () => {
        setPage(page + 1)
        setTs(Date.now())
    }

    const onSelect = (row) => {
        if (row===false) {
            setSelection([])
        }
        else if (row===true) {
            setSelection([].concat(rows))
        }
        else {
            let s = arrayToggle(selection, row)
            setSelection([].concat(s))
        }
    }

    const clearSelection = () => onSelect(false)

    return {
        params, status,
        rows, invType,
        count, onLoadMore,
        selection, onSelect, clearSelection,
        Last
    }
}

export default search

export const toParams = (p, page) => cleanObject(Object.assign({
    searchType: 'offers',
    pageNumber: 1,
    resultsPerPage: 10,
    marketCheckRequired: true,
    sort: [{
        field: 'holdMaturitySortDt',
        direction: 'ASC'
    }]
}, fixParams(p), { ...(page && {pageNumber: page})}))



// WEBPACK FOOTER //
// ./src/offerings/use-offerings.js